import { Common, commonLanguages, CommonLanguageType } from './common';
import { DefaultDevices } from './device';
import { EapScreenDisplayType, eapScreenDisplay } from './eap';
import { FuUnit } from './fu-unit';
import { GraphType } from './graphs';
import { OpsUnit } from './ops-unit';
import { DutyEngineerControlMode } from './duty-engineer-settings';

export interface SystemSpecification {
    id?: string;
    vesselId: string;
    keyboards: number;
    trackballs: number;
    hub: number;
    items: string;
    notes: string;
}

export enum PT100Type {
    UNDEFINED = 'undefined',
    WIRE_2 = '2-wire',
    WIRE_3 = '3-wire',
}

export enum ClassType {
    UNDEFINED = 'undefined',
    ABS = 'ABS',
}

export enum ResistanceType {
    UNDEFINED = 'undefined',
    JIS = 'New JIS',
}

type DeviceModel = { model: string | null; qty: number };
export type OpsWithModel = OpsUnit & { model: string | null };
type FuWithModel = { model: string | null; locations: string[]; qty: number };
export type FuUnitWithFcuIndex = FuUnit & { fcuIndex: number };

export class HardwareSpecification {
    [DefaultDevices.FCU]: DeviceModel;
    [DefaultDevices.HUB]: DeviceModel;
    [DefaultDevices.IEDGE]: DeviceModel;

    [DefaultDevices.EAP]: { display: EapScreenDisplayType; class: ClassType; fireAlarm: boolean };

    [DefaultDevices.OPS]: OpsWithModel[];

    [DefaultDevices.KEYBOARD]: DeviceModel;
    [DefaultDevices.TRACKBALL]: DeviceModel;

    [DefaultDevices.FU]: FuWithModel[];

    PT100?: { wiring: PT100Type; resitance: ResistanceType };

    constructor() {
        this[DefaultDevices.FCU] = { model: null, qty: 0 };
        this[DefaultDevices.HUB] = { model: null, qty: 0 };
        this[DefaultDevices.IEDGE] = { model: null, qty: 0 };

        this[DefaultDevices.EAP] = {
            display: eapScreenDisplay.LED,
            class: ClassType.ABS,
            fireAlarm: false,
        };

        this[DefaultDevices.OPS] = [];

        this[DefaultDevices.KEYBOARD] = { model: null, qty: 0 };
        this[DefaultDevices.TRACKBALL] = { model: null, qty: 0 };

        this[DefaultDevices.FU] = [];
    }
}

export interface SoftwareSpecificationApi {
    common: Common;
    hasMimics: boolean;
    graphs: {
        [GraphType.Bar]: boolean;
        [GraphType.Gauge]: boolean;
        [GraphType.Exhaust]: boolean;
    };
    dutySettings: DutyEngineerControlMode;
}

export class SoftwareSpecification {
    display: {
        language: CommonLanguageType;
        graphs: {
            [GraphType.Bar]: boolean;
            [GraphType.Gauge]: boolean;
            [GraphType.Exhaust]: boolean;
        };
        mimics: boolean;
        curve: boolean;
        control: boolean;
    };

    clock: {
        master: {
            hardware: boolean;
            input: boolean;
            server: boolean;
        };
        utc: boolean;
        internalBackup: boolean;
        batteryBackup: boolean;
    };
    dutySettings: DutyEngineerControlMode;

    constructor() {
        this.display = {
            language: commonLanguages.EN,
            graphs: {
                [GraphType.Bar]: false,
                [GraphType.Gauge]: false,
                [GraphType.Exhaust]: false,
            },
            mimics: false,
            curve: false,
            control: false,
        };

        this.clock = {
            master: {
                hardware: false,
                input: false,
                server: false,
            },
            utc: false,
            internalBackup: false,
            batteryBackup: false,
        };
        this.dutySettings = DutyEngineerControlMode.OPS_CONTROL;
    }
}

export interface OthersSpecification {
    items: string;
    notes: string;
}
